<script setup>
import {Link} from "@inertiajs/vue3";
import {ref} from "vue";
import classNames from "classnames";
import ArrowIcon from "@/Components/Icons/Home/ArrowIcon.vue";
import RegisterIcon from "@/Components/Icons/Home/RegisterIcon.vue";

defineProps({
    burgerMenuItem: {
        type: Boolean,
        default: false,
    }
});

const basicClasses = ref(`inline-flex justify-center items-center gap-2.5 focus:outline-none focus:ring-2 rounded-[10px] text-center transition text-white bg-primary-500 hover:bg-primary-400 focus:ring-primary-400 dark:bg-primary-500 dark:hover:bg-primary-400 dark:focus:ring-primary-600 md:px-8 md:py-3.5 text-lg leading-6 font-semibold`);
</script>

<template>
    <a
        :href="route('register')"
        :class="classNames(
            {[basicClasses]: true, ' p-3.5': !burgerMenuItem, ' w-full max-w-60 px-8 py-3.5': burgerMenuItem}
        )"
        aria-label="Go to registration"
    >
        <template v-if="burgerMenuItem">
            <span class="inline">Register</span>
            <ArrowIcon class="fill-white" />
        </template>

        <template v-else>
            <span class="hidden md:inline">Register</span>
            <ArrowIcon class="hidden md:block fill-white" />
            <RegisterIcon class="block md:hidden w-5 h-5 fill-white" />
        </template>
    </a>
</template>
